/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react-redux
import { useSelector, useDispatch } from "react-redux";
// react library for routing
import { useLocation, useHistory, NavLink as NavLinkRRD } from "react-router-dom";
// Firebase
import firebase from "firebase";
// nodejs library that concatenates classes
import classnames from "classnames";
// react plugin for creating notifications over the dashboard
import NotificationAlert from "react-notification-alert";
// react component used to create sweet alerts
import ReactBSAlert from "react-bootstrap-sweetalert";
// QR code generator
import QRCode from 'qrcode.react';
// Print
import { useReactToPrint } from 'react-to-print';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  Collapse,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
// react plugin used to create DropdownMenu for selecting items
import Select2 from "react-select2-wrapper";

// core components
import CardsHeader from "components/Headers/CardsHeader.js";
import Loading from "components/Misc/Loading";

// actions
import { createChecklist, deleteChecklist } from "actions/checklistActions";

const states = [
  "Alabama",
  "Alaska",
  "American Samoa",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District Of Columbia",
  "Federated States Of Micronesia",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Marshall Islands",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Northern Mariana Islands",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Palau",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virgin Islands",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

function Checklist() {
  // redux state
  const checklistsState = useSelector(state => state.checklists);
  const userState = useSelector(state => state.user);
  const dispatch = useDispatch();
  // local state
  const [state, setState] = React.useState({});
  const location = useLocation();
  const history = useHistory();
  const [modalAdd, setModalAdd] = React.useState(false);
  const [modalCopy, setModalCopy] = React.useState(false);
  const [locations, setLocations] = React.useState([]);
  const [checklistItems, setChecklistItems] = React.useState([]);
  const [loadingActive, setLoadingActive] = React.useState(false);
  const [modalTitle, setModalTitle] = React.useState(null);
  const [checklistToUpdate, setChecklistToUpdate] = React.useState(null);
  const [checklistToCopy, setChecklistToCopy] = React.useState(null);
  const [alert, setAlert] = React.useState(false);
  const [alternativeFranchise, setAlternativeFranchise] = React.useState(false);

  // Focus state
  const [focusedChecklistName, setFocusedChecklistName] = React.useState(false);
  const [focusedFranchiseSelect, setFocusedFranchiseSelect] = React.useState(
    false
  );
  const [focusedLocationSelect, setFocusedLocationSelect] = React.useState(
    false
  );
  const [focusedStartTime, setFocusedStartTime] = React.useState(false);
  const [focusedEndTime, setFocusedEndTime] = React.useState(false);
  const [
    focusedEnviroMasterChecklist,
    setFocusedEnviroMasterChecklist,
  ] = React.useState(false);

  // Content State
  const [checklistName, setChecklistName] = React.useState(null);
  const [franchiseSelect, setFranchiseSelect] = React.useState([]);
  const [locationSelect, setLocationSelect] = React.useState([]);
  const [startTime, setStartTime] = React.useState(null);
  const [endTime, setEndTime] = React.useState(null);
  const [enviroMasterChecklist, setEnviroMasterChecklist] = React.useState(
    userState.user.role === "owner" ? false : null
  );
  const [QRNeeded, setQRNeeded] = React.useState(false);
  const [streetNameState, setStreetNameState] = React.useState("");
  const [streetNumberState, setStreetNumberState] = React.useState("");
  const [stateState, setStateState] = React.useState("");
  // Weekday checkboxes
  const [mondayCheckbox, setMondayCheckbox] = React.useState(null);
  const [tuesdayCheckbox, setTuesdayCheckbox] = React.useState(null);
  const [wednesdayCheckbox, setWednesdayCheckbox] = React.useState(null);
  const [thursdayCheckbox, setThursdayCheckbox] = React.useState(null);
  const [fridayCheckbox, setFridayCheckbox] = React.useState(null);
  const [saturdayCheckbox, setSaturdayCheckbox] = React.useState(null);
  const [sundayCheckbox, setSundayCheckbox] = React.useState(null);

  // Validation State
  const [validChecklistName, setValidChecklistName] = React.useState(null);
  const [validFranchiseSelect, setValidFranchiseSelect] = React.useState(null);
  const [validLocationSelect, setValidLocationSelect] = React.useState(null);
  const [validStartTime, setValidStartTime] = React.useState(null);
  const [validEndTime, setValidEndTime] = React.useState(null);
  const [
    validEnviroMasterChecklist,
    setValidEnviroMasterChecklist,
  ] = React.useState(userState.user.role === "owner" ? "valid" : null);
  // Weekday checkboxes
  const [validMondayCheckbox, setValidMondayCheckbox] = React.useState(null);
  const [validTuesdayCheckbox, setValidTuesdayCheckbox] = React.useState(null);
  const [validWednesdayCheckbox, setValidWednesdayCheckbox] = React.useState(
    null
  );
  const [validThursdayCheckbox, setValidThursdayCheckbox] = React.useState(
    null
  );
  const [validFridayCheckbox, setValidFridayCheckbox] = React.useState(null);
  const [validSaturdayCheckbox, setValidSaturdayCheckbox] = React.useState(
    null
  );
  const [validSundayCheckbox, setValidSundayCheckbox] = React.useState(null);

  const notificationAlertRef = React.useRef(null);
  const qrCodeRef = React.useRef();

  const isLimitReached = () => {
    let checklists = 0;
    Object.keys(checklistsState.franchises).forEach(franchise => {
      if (checklists > 0) return;
      checklistsState.franchises[franchise].locations.forEach(location => {
        checklists += location.locationSpecificChecklists.length
      })
    })
    return (userState.user.role === 'owner' && userState.user.plan === 'free' && checklists > 0)
  }
  const notify = (type, title, message, icon) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon,
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const clearState = () => {
    setChecklistName(null);
    setFranchiseSelect([]);
    setLocationSelect([]);
    setStartTime(null);
    setEndTime(null);
    setEnviroMasterChecklist(userState.user.role === "owner" ? false : null);
    setQRNeeded(false);
    setMondayCheckbox(null);
    setTuesdayCheckbox(null);
    setWednesdayCheckbox(null);
    setThursdayCheckbox(null);
    setFridayCheckbox(null);
    setSaturdayCheckbox(null);
    setSundayCheckbox(null);
    setChecklistToUpdate(null);
    setChecklistItems([]);
    setModalTitle(null);
    // CLEAR VALIDATIONS
    setValidChecklistName(null);
    setValidFranchiseSelect(null);
    setValidLocationSelect(null);
    setValidStartTime(null);
    setValidEndTime(null);
    setValidEnviroMasterChecklist(userState.user.role === "owner" ? "valid" : null);
    setValidMondayCheckbox(null);
    setValidTuesdayCheckbox(null);
    setValidWednesdayCheckbox(null);
    setValidThursdayCheckbox(null);
    setValidFridayCheckbox(null);
    setValidSaturdayCheckbox(null);
    setValidSundayCheckbox(null);
  };

  const getCollapseInitialState = routes => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (location.pathname.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  };

  const activeRoute = routeName => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  const closeSidenav = () => {
    if (window.innerWidth < 1200) {
    }
  };

  const handleDelete = async (prop) => {
    setLoadingActive(true);
    try {
      await dispatch(deleteChecklist({
        type: prop.source.type,
        franchise: prop.source.franchise,
        location: prop.source.location,
        name: prop.source.name
      }))

      notify(
        "success",
        "Success!",
        `Checklist ${prop.source.name} was deleted successfully`,
        "fas fa-check"
      );
      setLocations(
        Object.keys(checklistsState.franchises).map(franchise => {
          return {
            collapse: true,
            name: franchise,
            state: `${franchise}Collapse`,
            views: [
              {
                title: true,
                name: "General Checklists",
              },
              ...checklistsState.franchises[franchise].generalChecklists.map(
                generalChecklist => ({
                  checklistItem: true,
                  name: generalChecklist.name,
                  source: {
                    franchise,
                    type: "generalChecklists",
                    name: generalChecklist.name,
                  },
                })
              ),
              {
                title: true,
                name: "Locations",
              },
              ...checklistsState.franchises[franchise].locations.map(
                location => ({
                  collapse: true,
                  name: location.address,
                  state: `${location.address}Collapse`,
                  views: location.locationSpecificChecklists.map(checklist => ({
                    checklistItem: true,
                    name: checklist.name,
                    source: {
                      franchise,
                      location: location.address,
                      type: "locationSpecificChecklists",
                      name: checklist.name,
                    },
                  })),
                })
              ),
            ],
          };
        })
      );
      setLoadingActive(false);
    } catch (error) {
      console.error(error);
      setLoadingActive(false);
    }
  }

  const warningAlert = (prop) => {
    setAlert(
      <ReactBSAlert
        warning
        showCancel
        style={{ display: "block", marginTop: "-100px" }}
        title="Warning"
        onConfirm={() => {
          handleDelete(prop);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="warning"
        confirmBtnText="Yes, delete it!"
        cancelBtnBsStyle="primary"
        cancelBtnText="Cancel"
        btnSize=""
      >
        You are about to delete the <strong>{prop.source.franchise}'s {prop.source.name} {prop.source.type === "generalChecklists" ? 'General Checklist' : `Checklist at ${prop.source.location}`}</strong>. Are you sure you want to do this? The statistics for this checklist will not be removed, but it won't show to complete anymore, and will not be considered from now on.
      </ReactBSAlert>
    );
  };

  const configureSettingsToUpdate = (prop) => {
    if (prop.source.type === "generalChecklists") {
      setChecklistToUpdate({
        franchise: prop.source.franchise,
        location: "All Locations (General Checklist)",
        checklist:
          checklistsState.franchises[
            prop.source.franchise
          ].generalChecklists.filter(
            checklist => checklist.name === prop.source.name
          )[0]
        });
    } else {
      setChecklistToUpdate({
        franchise: prop.source.franchise,
        location: prop.source.location,
        checklist:
          checklistsState.franchises[prop.source.franchise].locations
            .filter(
              location => location.address === prop.source.location
            )[0]
            .locationSpecificChecklists.filter(
              checklist => checklist.name === prop.source.name
            )[0]
      })
    }
  }

  const createLinks = routes => {
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.title) {
        return (
          <div key={prop.name}>
            <hr className="my-3" style={{ borderColor: "white" }} />
            <h4 className="navbar-heading p-0 text-muted">
              <span className="docs-normal text-white">{prop.name}</span>
            </h4>
          </div>
        );
      }
      if (prop.checklistItem) {
        return (
          <NavItem className={activeRoute(prop.layout + prop.path)} key={key}>
            <NavLink
              to="#"
              activeClassName=""
              onClick={() => configureSettingsToUpdate(prop)}
              tag={NavLinkRRD}
            >
              <div className="d-flex justify-content-between w-100">
                  <span className="text-white">{prop.name}</span>
                  { userState.user.role === 'em' || userState.user.role === 'dtec' || prop.source.type !== 'generalChecklists' ?
                    (<span>
                        <i className="far fa-copy text-primary pr-3" onClick={e => {
                          setModalCopy(true);
                          setChecklistToCopy(prop)
                          e.stopPropagation();
                          e.preventDefault();
                        }}/>
                        <i className="far fa-trash-alt text-danger" onClick={e => {
                          warningAlert(prop);
                          e.stopPropagation();
                          e.preventDefault();
                        }}/>
                      </span>)
                    :
                    null
                  }
                </div>
            </NavLink>
          </NavItem>
        );
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <NavItem key={key}>
            <NavLink
              href="#"
              data-toggle="collapse"
              aria-expanded={state[prop.state]}
              style={{
                fontSize: prop.state.includes("franchise")
                  ? "1.5rem"
                  : "1.2rem",
              }}
              className={
                "text-white" +
                classnames({
                  active: getCollapseInitialState(prop.views),
                })
              }
              onClick={e => {
                e.preventDefault();
                setState(prevState => {
                  return {
                    ...prevState,
                    [prop["state"]]: !prevState[prop["state"]],
                  };
                });
              }}
            >
              {prop.name}
            </NavLink>
            <Collapse isOpen={state[prop.state]}>
              <Nav className="nav-sm flex-column">
                {createLinks(prop.views)}
              </Nav>
            </Collapse>
          </NavItem>
        );
      }
      return (
        <NavItem className={activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink
            to="#"
            activeClassName=""
            onClick={closeSidenav}
            tag={NavLinkRRD}
          >
            {prop.icon !== undefined ? (
              <>
                <i className={prop.icon} />
                <span className="nav-link-text text-white">{prop.name}</span>
              </>
            ) : prop.miniName !== undefined ? (
              <>
                <span className="sidenav-normal text-white"> {prop.name} </span>
              </>
            ) : (
              prop.name
            )}
          </NavLink>
        </NavItem>
      );
    });
  };

  const removeItem = index => {
    const items = document.getElementsByClassName("checklist-item");
    setChecklistItems(prevState => {
      const currentItems = [...items].map(item => item.value);
      if (index === 0 && prevState.length === 1) {
        return [];
      }
      const newItems = currentItems
        .slice(0, index)
        .concat(currentItems.slice(index + 1));
      return newItems;
    });
  };

  const addChecklistItem = () => {
    setChecklistItems(prevState => prevState.concat([""]));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (isLimitReached()) {
      return setAlert(
        <ReactBSAlert
          warning
          showCancel
          style={{ display: "block", marginTop: "-100px" }}
          title="Uh-Oh!"
          onConfirm={() => {
            setAlert(null);
            history.push("/admin/billing");
          }}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Yes, let's upgrade!"
          cancelBtnBsStyle="secondary"
          cancelBtnText="Cancel"
          btnSize=""
        >
          You have already used your free checklist. Upgrade to enjoy unlimited checklists, unlimited mobile app accounts, user feedback, and much more!
        </ReactBSAlert>
      );
    }
    setLoadingActive(true);
    const items = [...document.getElementsByClassName("checklist-item")].map(item => item.value);
    try {
      if (
        validChecklistName === "valid" &&
        validFranchiseSelect === "valid" &&
        validLocationSelect === "valid" &&
        validStartTime === "valid" &&
        validEndTime === "valid" &&
        validEnviroMasterChecklist === "valid" &&
        (validMondayCheckbox === "valid" ||
          validTuesdayCheckbox === "valid" ||
          validWednesdayCheckbox === "valid" ||
          validThursdayCheckbox === "valid" ||
          validFridayCheckbox === "valid" ||
          validSaturdayCheckbox === "valid" ||
          validSundayCheckbox === "valid") &&
          items.length > 0
      ) {
        const weekDays = [];
        if (mondayCheckbox) weekDays.push("Mon");
        if (tuesdayCheckbox) weekDays.push("Tue");
        if (wednesdayCheckbox) weekDays.push("Wed");
        if (thursdayCheckbox) weekDays.push("Thu");
        if (fridayCheckbox) weekDays.push("Fri");
        if (saturdayCheckbox) weekDays.push("Sat");
        if (sundayCheckbox) weekDays.push("Sun");
        const locations = [];
        if (locationSelect[0] === "All Locations (General Checklist)") {
          locations.push({
            franchise: franchiseSelect,
            location: "general",
          });
        } else {
          franchiseSelect.forEach(franchise => {
            locationSelect.forEach(location => {
              checklistsState.franchises[franchise].locations.forEach(
                franchiseLocation => {
                  if (franchiseLocation.address === location)
                    return locations.push({
                      franchise,
                      location: franchiseLocation.address,
                    });
                }
              );
            });
          });
        }
        await dispatch(
          createChecklist({
            name: checklistName,
            locations,
            checklist: {
              startTime,
              endTime,
              enviroMasterChecklist,
              items,
              QRNeeded,
              weekDays,
            },
          })
        );
        setLocations(
          Object.keys(checklistsState.franchises).map(franchise => {
            return {
              collapse: true,
              name: franchise,
              state: `${franchise}Collapse`,
              views: [
                {
                  title: true,
                  name: "General Checklists",
                },
                ...checklistsState.franchises[franchise].generalChecklists.map(
                  generalChecklist => ({
                    checklistItem: true,
                    name: generalChecklist.name,
                    source: {
                      franchise,
                      type: "generalChecklists",
                      name: generalChecklist.name,
                    },
                  })
                ),
                {
                  title: true,
                  name: "Locations",
                },
                ...checklistsState.franchises[franchise].locations.map(
                  location => ({
                    collapse: true,
                    name: location.address,
                    state: `${location.address}Collapse`,
                    views: location.locationSpecificChecklists.map(
                      checklist => ({
                        checklistItem: true,
                        name: checklist.name,
                        source: {
                          franchise,
                          location: location.address,
                          type: "locationSpecificChecklists",
                          name: checklist.name,
                        },
                      })
                    ),
                  })
                ),
              ],
            };
          })
        );
        setModalAdd(false);
        setLoadingActive(false);
        notify(
          "success",
          "Success!",
          modalTitle === 'Add New Checklist' ? `Checklist ${checklistName} was created successfully` : `Checklist ${checklistName} was updated successfully`,
          "fas fa-check"
        );
        clearState();
      } else {
        let message = "";
        if (validChecklistName !== "valid")
          message += "Please provide the name of the checklist.\n";
        if (validFranchiseSelect !== "valid")
          message += "Please select at least one franchise.\n";
        if (validLocationSelect !== "valid")
          message += "Please select at least one location.\n";
        if (validStartTime !== "valid")
          message +=
            "Please provide a starting time to enable the filling of this checklist.\n";
        if (validEndTime !== "valid")
          message +=
            "Please provide a limit time for the checklist to be completed on time.\n";
        if (validEnviroMasterChecklist !== "valid")
          message +=
            "Please select if the checklist should be filled out by a technician or by a manager.\n";
        if (
          validMondayCheckbox !== "valid" &&
          validTuesdayCheckbox !== "valid" &&
          validWednesdayCheckbox !== "valid" &&
          validThursdayCheckbox !== "valid" &&
          validFridayCheckbox !== "valid" &&
          validSaturdayCheckbox !== "valid" &&
          validSundayCheckbox !== "valid"
        )
          message +=
            "Please select at least one day when the checklist should be filled out.\n";
        if (checklistItems.length === 0)
          message += "Please add at least one item to the checklist.\n";

        setLoadingActive(false);
        notify(
          "danger",
          "Please make sure everything is filled out correctly:",
          message,
          "fas fa-exclamation-triangle"
        );
      }
    } catch (error) {
      console.error(error);
      setModalAdd(false);
      return notify(
        "danger",
        "Uh Oh!",
        error.message,
        "fas fa-exclamation-triangle"
      );
    }
  };

  const modalOpen = async (type) => {
    if (type === 'add') {
      setModalTitle('Add New Checklist')
    } else {
      await setChecklistName(checklistToUpdate.checklist.name);
      await setFranchiseSelect([checklistToUpdate.franchise]);
      await setLocationSelect([checklistToUpdate.location]);
      await setStartTime(checklistToUpdate.checklist.startTime);
      await setEndTime(checklistToUpdate.checklist.endTime);
      await setEnviroMasterChecklist(checklistToUpdate.checklist.enviroMasterChecklist);
      await setMondayCheckbox(checklistToUpdate.checklist.weekDays.includes('Mon'));
      await setTuesdayCheckbox(checklistToUpdate.checklist.weekDays.includes('Tue'));
      await setWednesdayCheckbox(checklistToUpdate.checklist.weekDays.includes('Wed'));
      await setThursdayCheckbox(checklistToUpdate.checklist.weekDays.includes('Thu'));
      await setFridayCheckbox(checklistToUpdate.checklist.weekDays.includes('Fri'));
      await setSaturdayCheckbox(checklistToUpdate.checklist.weekDays.includes('Sat'));
      await setSundayCheckbox(checklistToUpdate.checklist.weekDays.includes('Sun'));
      await setChecklistItems(checklistToUpdate.checklist.items);
      await setQRNeeded(checklistToUpdate.checklist.QRNeeded);
      // Set all fields to valid
      await setValidChecklistName('valid');
      await setValidFranchiseSelect('valid');
      await setValidLocationSelect('valid');
      await setValidStartTime('valid');
      await setValidEndTime('valid');
      await setValidEnviroMasterChecklist('valid');
      await setValidMondayCheckbox('valid');
      await setValidTuesdayCheckbox('valid');
      await setValidWednesdayCheckbox('valid');
      await setValidThursdayCheckbox('valid');
      await setValidFridayCheckbox('valid');
      await setValidSaturdayCheckbox('valid');
      await setValidSundayCheckbox('valid');
      await setModalTitle('Update Checklist')
    }
  }

  const handleCopy = async (e) => {
    e.preventDefault();
    setLoadingActive(true);
    try {
      if (
        validFranchiseSelect === "valid" &&
        validLocationSelect === "valid"
      ) {
        const locations = [];

        // Verify that the checklist is not already on the target location
        let valid = true;
        if (locationSelect[0] === 'All Locations (General Checklist)') {
          franchiseSelect.forEach(franchise => {
            if (!valid) return;
            checklistsState.franchises[franchise].generalChecklists.forEach(checklist => {
              if (checklist.name === checklistToCopy.name) {
                return valid = false;
              }
            })
          })
          locations.push({
            franchise: franchiseSelect,
            location: "general",
          });
        } else {
          franchiseSelect.forEach(franchise => {
            if (!valid) return;
            locationSelect.forEach(location => {
              if (!valid) return;
              checklistsState.franchises[franchise].locations.forEach(
                (franchiseLocation, index) => {
                  if (!valid) return;
                  checklistsState.franchises[franchise].locations[index].locationSpecificChecklists.forEach(locationChecklist => {
                    if (locationChecklist.name === checklistToCopy.name) {
                      return valid = false;
                    }
                  })
                  if (franchiseLocation.address === location)
                    return locations.push({
                      franchise,
                      location: franchiseLocation.address,
                    });
                }
              );
            });
          });
        }

        if (!valid) {
          return notify(
            "danger",
            "Uh-Oh!",
            'The checklist you are trying to copy already exists in one or more of the targeted locations.',
            "fas fa-exclamation-triangle"
          );
        }
        
        const checklist = checklistToCopy.source.type === 'generalChecklists' ?
          checklistsState
          .franchises[checklistToCopy.source.franchise]
          .generalChecklists.filter(checklist => checklist.name === checklistToCopy.name)[0]
          : 
          checklistsState
          .franchises[checklistToCopy.source.franchise]
          .locations.filter(location => location.address === checklistToCopy.source.location)[0]
          .locationSpecificChecklists.filter(locationChecklist => locationChecklist.name === checklistToCopy.name)[0];

        await dispatch(
          createChecklist({
            name: checklist.name,
            locations,
            checklist: {
              startTime: checklist.startTime,
              endTime: checklist.endTime,
              enviroMasterChecklist: checklist.enviroMasterChecklist,
              items: checklist.items,
              QRNeeded: checklist.QRNeeded,
              weekDays: checklist.weekDays,
            },
          })
        );
        setLocations(
          Object.keys(checklistsState.franchises).map(franchise => {
            return {
              collapse: true,
              name: franchise,
              state: `${franchise}Collapse`,
              views: [
                {
                  title: true,
                  name: "General Checklists",
                },
                ...checklistsState.franchises[franchise].generalChecklists.map(
                  generalChecklist => ({
                    checklistItem: true,
                    name: generalChecklist.name,
                    source: {
                      franchise,
                      type: "generalChecklists",
                      name: generalChecklist.name,
                    },
                  })
                ),
                {
                  title: true,
                  name: "Locations",
                },
                ...checklistsState.franchises[franchise].locations.map(
                  location => ({
                    collapse: true,
                    name: location.address,
                    state: `${location.address}Collapse`,
                    views: location.locationSpecificChecklists.map(
                      checklist => ({
                        checklistItem: true,
                        name: checklist.name,
                        source: {
                          franchise,
                          location: location.address,
                          type: "locationSpecificChecklists",
                          name: checklist.name,
                        },
                      })
                    ),
                  })
                ),
              ],
            };
          })
        );
        setModalCopy(false);
        setLoadingActive(false);
        if (checklistsState.status === 'OK') {
          notify(
            "success",
            "Success!",
            'The checklist was copied successfully',
            "fas fa-check"
          );
        } else {
          notify(
            "danger",
            "Uh-Oh!",
            'Something went wrong. Please try again later',
            "fas fa-check"
          );
        }
        clearState();
      } else {
        let message = "";
        if (validFranchiseSelect !== "valid")
          message += "Please select at least one franchise.\n";
        if (validLocationSelect !== "valid")
          message += "Please select at least one location.\n";

        setLoadingActive(false);
        notify(
          "danger",
          "Please make sure everything is filled out correctly:",
          message,
          "fas fa-exclamation-triangle"
        );
      }
    } catch (error) {
      console.error(error);
      setModalAdd(false);
      return notify(
        "danger",
        "Uh Oh!",
        error.message,
        "fas fa-exclamation-triangle"
      );
    }
  }

  const handlePrint = useReactToPrint({
    content: () => qrCodeRef.current,
  })

  React.useEffect(() => {
    if (modalTitle) setModalAdd(true)
  }, [modalTitle])

  React.useEffect(() => {
    if (checklistToUpdate) {
      modalOpen('update');
    }
  }, checklistToUpdate)

  React.useEffect(() => {
    setLocations(
      Object.keys(checklistsState.franchises).map(franchise => {
        return {
          collapse: true,
          name: franchise,
          state: `${franchise}Collapse`,
          views: [
            {
              title: true,
              name: "General Checklists",
            },
            ...checklistsState.franchises[franchise].generalChecklists.map(
              generalChecklist => ({
                checklistItem: true,
                name: generalChecklist.name,
                source: {
                  franchise,
                  type: "generalChecklists",
                  name: generalChecklist.name,
                },
              })
            ),
            {
              title: true,
              name: "Locations",
            },
            ...checklistsState.franchises[franchise].locations.map(
              location => ({
                collapse: true,
                name: location.address,
                state: `${location.address}Collapse`,
                views: location.locationSpecificChecklists.map(checklist => ({
                  checklistItem: true,
                  name: checklist.name,
                  source: {
                    franchise,
                    location: location.address,
                    type: "locationSpecificChecklists",
                    name: checklist.name,
                  },
                })),
              })
            ),
          ],
        };
      })
    );
  }, [checklistsState.franchises, checklistsState.locations]);

  React.useEffect(() => {
    if (franchiseSelect.length === 0) {
      setValidFranchiseSelect("invalid");
    } else {
      setValidFranchiseSelect("valid");
    }
  }, [franchiseSelect.length]);

  React.useEffect(() => {
    if (locationSelect.length === 0) {
      setValidLocationSelect("invalid");
    } else {
      setValidLocationSelect("valid");
    }
  }, [locationSelect.length]);

  return (
    <>
      {alert}
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Loading active={loadingActive} />
      <CardsHeader name="Checklists" parentName="Checklist" />
      <Container className="mt--6 checklist" fluid>
        <Row>
          <div className="col checklist-table">
            <Card className="bg-default text-white pb-3">
              <CardHeader className="border-0 bg-transparent text-white d-flex">
                <h3 className="mb-0 text-white">Checklists</h3>
                <div className="ml-auto">
                  <Button
                    color="primary"
                    outline
                    type="button"
                    onClick={() => modalOpen('add')}
                  >
                    Add Checklist
                  </Button>
                </div>
              </CardHeader>
              <Collapse navbar isOpen={true}>
                <Nav navbar>{createLinks(locations)}</Nav>
              </Collapse>
            </Card>
          </div>

          <Modal
            isOpen={modalAdd}
            toggle={() => {
              setModalAdd(false);
              clearState();
            }}
            className="modal-dialog-centered modal-secondary"
            style={{ width: "90%", maxWidth: "1200px" }}
          >
            <div className="modal-body">
              <Row>
                <div className="col">
                  <Card className="shadow px-6">
                    <CardHeader className="bg-transparent border-0">
                      <h3 className="mb-0">{modalTitle}</h3>
                    </CardHeader>
                    <Form
                      className="edit-event--form pt-3"
                      id="form"
                      onSubmit={e => handleSubmit(e)}
                    >
                      <FormGroup
                        className={classnames({
                          focused: focusedChecklistName,
                        })}
                      >
                        <InputGroup className="input-group-merge mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText
                              style={
                                validChecklistName === "valid"
                                  ? { borderColor: "#2dce89" }
                                  : validChecklistName === "invalid"
                                  ? { borderColor: "red" }
                                  : {}
                              }
                            >
                              <i className="ni ni-bullet-list-67" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            id="validationCustom01"
                            placeholder="Checklist Name"
                            type="text"
                            disabled={checklistToUpdate ? true : false}
                            defaultValue={checklistName}
                            valid={validChecklistName === "valid"}
                            invalid={validChecklistName === "invalid"}
                            onFocus={() => setFocusedChecklistName(true)}
                            onBlur={() => setFocusedChecklistName(false)}
                            onChange={e => {
                              setChecklistName(e.target.value);
                              if (e.target.value === "") {
                                setValidChecklistName("invalid");
                              } else {
                                setValidChecklistName("valid");
                              }
                            }}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <label
                          className="text-muted"
                          htmlFor="exampleFormControlSelect2"
                        >
                          Select the franchises the checklist will be applied
                          to.
                        </label>
                        <Select2
                          className="form-control"
                          multiple
                          data={Object.keys(checklistsState.franchises)}
                          // style={validFranchiseSelect === "valid" ? {borderColor: '#2dce89'} : validFranchiseSelect === "invalid" ? {borderColor: '#fb6340'} : {}}
                          onFocus={() => setFocusedFranchiseSelect(true)}
                          onBlur={() => setFocusedFranchiseSelect(false)}
                          disabled={checklistToUpdate ? true : false}
                          onSelect={e => {
                            setFranchiseSelect(prevState =>
                              prevState.concat([e.params.data.text])
                            );
                          }}
                          onUnselect={e => {
                            setFranchiseSelect(prevState =>
                              prevState.filter(
                                franchise => franchise !== e.params.data.text
                              )
                            );
                          }}
                          value={franchiseSelect}
                        />
                      </FormGroup>
                      {franchiseSelect.length > 0 ? (
                        locationSelect.length === 0 && userState.user.role !== 'owner' ? (
                          <FormGroup>
                            <label
                              className="text-muted"
                              htmlFor="exampleFormControlSelect2"
                            >
                              Please select the location(s) where this checklist
                              should be completed
                            </label>
                            <Select2
                              className="form-control"
                              multiple
                              disabled={checklistToUpdate ? true : false}
                              data={[
                                "All Locations (General Checklist)",
                                ...Object.keys(checklistsState.franchises)
                                  .map(franchise => {
                                    if (!franchiseSelect.includes(franchise))
                                      return null;
                                    return [
                                      ...checklistsState.franchises[
                                        franchise
                                      ].locations.map(
                                        location => location.address
                                      ),
                                    ];
                                  })
                                  .flat()
                                  .filter(item => item),
                              ]}
                              // style={validFranchiseSelect === "valid" ? {borderColor: '#2dce89'} : validFranchiseSelect === "invalid" ? {borderColor: '#fb6340'} : {}}
                              onFocus={() => setFocusedLocationSelect(true)}
                              onBlur={() => setFocusedLocationSelect(false)}
                              onSelect={e => {
                                setLocationSelect(prevState =>
                                  prevState.includes(e.params.data.text)
                                    ? prevState
                                    : prevState.concat([e.params.data.text])
                                );
                              }}
                              onUnselect={e => {
                                setLocationSelect(prevState =>
                                  prevState.filter(
                                    location => location !== e.params.data.text
                                  )
                                );
                              }}
                              value={locationSelect}
                            />
                            <div className="invalid-feedback">
                              Please choose a username.
                            </div>
                          </FormGroup>
                        ) : locationSelect.includes(
                            "All Locations (General Checklist)"
                          ) ? (
                          <FormGroup>
                            <label
                              className="text-muted"
                              htmlFor="exampleFormControlSelect2"
                            >
                              Please select the location(s) where this checklist
                              should be completed
                            </label>
                            <Select2
                              className="form-control"
                              multiple
                              disabled={checklistToUpdate ? true : false}
                              data={["All Locations (General Checklist)"]}
                              // style={validFranchiseSelect === "valid" ? {borderColor: '#2dce89'} : validFranchiseSelect === "invalid" ? {borderColor: '#fb6340'} : {}}
                              onFocus={() => setFocusedLocationSelect(true)}
                              onBlur={() => setFocusedLocationSelect(false)}
                              onSelect={e => {
                                setLocationSelect(prevState =>
                                  prevState.includes(e.params.data.text)
                                    ? prevState
                                    : prevState.concat([e.params.data.text])
                                );
                              }}
                              onUnselect={e => {
                                setLocationSelect(prevState =>
                                  prevState.filter(
                                    location => location !== e.params.data.text
                                  )
                                );
                              }}
                              value={locationSelect}
                            />
                          </FormGroup>
                        ) : (
                          <FormGroup>
                            <label
                              className="text-muted"
                              htmlFor="exampleFormControlSelect2"
                            >
                              Please select the location(s) where this checklist
                              should be completed
                            </label>
                            <Select2
                              className="form-control"
                              multiple
                              disabled={checklistToUpdate ? true : false}
                              data={Object.keys(checklistsState.franchises)
                                .map(franchise => {
                                  if (!franchiseSelect.includes(franchise))
                                    return null;
                                  return [
                                    ...checklistsState.franchises[
                                      franchise
                                    ].locations.map(
                                      location => location.address
                                    ),
                                  ];
                                })
                                .flat()
                                .filter(item => item)}
                              // style={validFranchiseSelect === "valid" ? {borderColor: '#2dce89'} : validFranchiseSelect === "invalid" ? {borderColor: '#fb6340'} : {}}
                              onFocus={() => setFocusedLocationSelect(true)}
                              onBlur={() => setFocusedLocationSelect(false)}
                              onSelect={e => {
                                setLocationSelect(prevState =>
                                  prevState.includes(e.params.data.text)
                                    ? prevState
                                    : prevState.concat([e.params.data.text])
                                );
                              }}
                              onUnselect={e => {
                                setLocationSelect(prevState =>
                                  prevState.filter(
                                    location => location !== e.params.data.text
                                  )
                                );
                              }}
                              value={locationSelect}
                            />
                          </FormGroup>
                        )
                      ) : null}
                      {checklistItems.map((item, index) => (
                        <Row key={item !== "" ? item : index}>
                          <Col xs="10">
                            <Input
                              style={{
                                background: "transparent",
                                border: "none",
                              }}
                              autoFocus={item === "" ? true : false}
                              defaultValue={item}
                              className="checklist-item"
                              type="text"
                            />
                          </Col>
                          <Col className="text-right" xs="2">
                            <i
                              className="far fa-trash-alt text-danger mt-3"
                              onClick={() => removeItem(index)}
                              style={{ cursor: "pointer", display: (
                                userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)" ? 'none' : 'block'
                              ) }}
                            />
                          </Col>
                        </Row>
                      ))}
                      <Row className="mt-4">
                        <Col>
                          <Button
                            color="primary"
                            outline
                            type="button"
                            onClick={addChecklistItem}
                            disabled={userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)"}
                          >
                            Add Checklist Item
                          </Button>
                        </Col>
                      </Row>
                      <Row className="mt-5 pb-5">
                        <Col>
                          <FormGroup>
                            <label
                              style={{
                                background: "transparent",
                              }}
                              className="form-control-label text-muted"
                              htmlFor="startTime"
                            >
                              Start Time
                            </label>
                            <Input
                              style={{
                                background: "transparent",
                              }}
                              defaultValue={startTime}
                              id="startTime"
                              type="time"
                              valid={validStartTime === "valid"}
                              invalid={validStartTime === "invalid"}
                              onFocus={() => setFocusedStartTime(true)}
                              onBlur={() => setFocusedStartTime(false)}
                              onChange={e => {
                                setStartTime(e.target.value);
                                if (e.target.value !== null) {
                                  setValidStartTime("valid");
                                } else {
                                  setValidStartTime("invalid");
                                }
                              }}
                              disabled={userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)"}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label
                              style={{
                                background: "transparent",
                              }}
                              className="form-control-label text-muted"
                              htmlFor="endTime"
                            >
                              End Time
                            </label>
                            <Input
                              style={{
                                background: "transparent",
                              }}
                              className="checklist-input"
                              defaultValue={endTime}
                              id="endTime"
                              type="time"
                              valid={validEndTime === "valid"}
                              invalid={validEndTime === "invalid"}
                              onFocus={() => setFocusedEndTime(true)}
                              onBlur={() => setFocusedEndTime(false)}
                              onChange={e => {
                                setEndTime(e.target.value);
                                if (
                                  e.target.value !== null &&
                                  Number(startTime.split(":").join("")) <=
                                    Number(e.target.value.split(":").join(""))
                                ) {
                                  setValidEndTime("valid");
                                } else {
                                  setValidEndTime("invalid");
                                }
                              }}
                              disabled={userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)"}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <h4 className="text-muted">
                        Select the days of the week you would like this
                        checklist completed.
                      </h4>
                      <Row className="mt-n4">
                        <Col>
                          <div className="custom-control custom-control-alternative custom-checkbox ml-2 mt-4 pt-1">
                            <input
                              id="Monday"
                              type="checkbox"
                              className="custom-control-input"
                              onChange={e => {
                                setMondayCheckbox(e.target.checked);
                                if (e.target.checked === false) {
                                  setValidMondayCheckbox("invalid");
                                } else {
                                  setValidMondayCheckbox("valid");
                                }
                              }}
                              disabled={userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)"}
                              defaultChecked={mondayCheckbox}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="Monday"
                            ></label>
                            {/* {validCheckboxState === "invalid" ? (
                              <div className="invalid-feedback">
                                You must agree before submitting.
                              </div>
                            ) : (
                              <></>
                            )} */}
                          </div>
                        </Col>
                        <Col>
                          <div className="custom-control custom-control-alternative custom-checkbox ml-2 mt-4 pt-1">
                            <input
                              id="Tuesday"
                              type="checkbox"
                              className="custom-control-input"
                              onChange={e => {
                                setTuesdayCheckbox(e.target.checked);
                                if (e.target.checked === false) {
                                  setValidTuesdayCheckbox("invalid");
                                } else {
                                  setValidTuesdayCheckbox("valid");
                                }
                              }}
                              disabled={userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)"}
                              defaultChecked={tuesdayCheckbox}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="Tuesday"
                            ></label>
                          </div>
                        </Col>
                        <Col>
                          <div className="custom-control custom-control-alternative custom-checkbox ml-2 mt-4 pt-1">
                            <input
                              id="Wednesday"
                              type="checkbox"
                              className="custom-control-input"
                              onChange={e => {
                                setWednesdayCheckbox(e.target.checked);
                                if (e.target.checked === false) {
                                  setValidWednesdayCheckbox("invalid");
                                } else {
                                  setValidWednesdayCheckbox("valid");
                                }
                              }}
                              disabled={userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)"}
                              defaultChecked={wednesdayCheckbox}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="Wednesday"
                            ></label>
                          </div>
                        </Col>
                        <Col>
                          <div className="custom-control custom-control-alternative custom-checkbox ml-2 mt-4 pt-1">
                            <input
                              id="Thursday"
                              type="checkbox"
                              className="custom-control-input"
                              onChange={e => {
                                setThursdayCheckbox(e.target.checked);
                                if (e.target.checked === false) {
                                  setValidThursdayCheckbox("invalid");
                                } else {
                                  setValidThursdayCheckbox("valid");
                                }
                              }}
                              disabled={userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)"}
                              defaultChecked={thursdayCheckbox}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="Thursday"
                            ></label>
                          </div>
                        </Col>
                        <Col>
                          <div className="custom-control custom-control-alternative custom-checkbox ml-1 mt-4 pt-1">
                            <input
                              id="Friday"
                              type="checkbox"
                              className="custom-control-input"
                              onChange={e => {
                                setFridayCheckbox(e.target.checked);
                                if (e.target.checked === false) {
                                  setValidFridayCheckbox("invalid");
                                } else {
                                  setValidFridayCheckbox("valid");
                                }
                              }}
                              disabled={userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)"}
                              defaultChecked={fridayCheckbox}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="Friday"
                            ></label>
                          </div>
                        </Col>
                        <Col>
                          <div className="custom-control custom-control-alternative custom-checkbox ml-2 mt-4 pt-1">
                            <input
                              id="Saturday"
                              type="checkbox"
                              className="custom-control-input"
                              onChange={e => {
                                setSaturdayCheckbox(e.target.checked);
                                if (e.target.checked === false) {
                                  setValidSaturdayCheckbox("invalid");
                                } else {
                                  setValidSaturdayCheckbox("valid");
                                }
                              }}
                              disabled={userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)"}
                              defaultChecked={saturdayCheckbox}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="Saturday"
                            ></label>
                          </div>
                        </Col>
                        <Col>
                          <div className="custom-control custom-control-alternative custom-checkbox ml-2 mt-4 pt-1">
                            <input
                              id="Sunday"
                              type="checkbox"
                              className="custom-control-input"
                              onChange={e => {
                                setSundayCheckbox(e.target.checked);
                                if (e.target.checked === false) {
                                  setValidSundayCheckbox("invalid");
                                } else {
                                  setValidSundayCheckbox("valid");
                                }
                              }}
                              disabled={userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)"}
                              defaultChecked={sundayCheckbox}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="Sunday"
                            ></label>
                          </div>
                        </Col>
                      </Row>
                      <Row className="pb-5">
                        <Col>
                          <label>
                            <span className="text-muted mt-n2">Mon</span>
                          </label>
                        </Col>
                        <Col>
                          <label>
                            <span className="text-muted mt-n2">Tue</span>
                          </label>
                        </Col>
                        <Col>
                          <label>
                            <span className="text-muted mt-n2">Wed</span>
                          </label>
                        </Col>
                        <Col>
                          <label>
                            <span className="text-muted mt-n2">Thu</span>
                          </label>
                        </Col>
                        <Col>
                          <label>
                            <span className="text-muted mt-n2">Fri</span>
                          </label>
                        </Col>
                        <Col>
                          <label>
                            <span className="text-muted mt-n2">Sat</span>
                          </label>
                        </Col>
                        <Col>
                          <label>
                            <span className="text-muted mt-n2">Sun</span>
                          </label>
                        </Col>
                      </Row>
                      <Row className="pb-5">
                        <Col>
                          <span className="text-muted mt-n2">
                            Requires QR code reading
                          </span>
                          <span className="ml-3">
                            <label className="custom-toggle text-primary">
                              <input
                                type="checkbox"
                                className="text-primary"
                                defaultChecked={QRNeeded}
                                id="requiresCodeRead"
                                onChange={e => {
                                  setQRNeeded(e.target.checked);
                                }}
                                disabled={userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)"}
                              />
                              <span
                                className="custom-toggle-slider rounded-circle text-primary"
                                data-label-off="No"
                                data-label-on="Yes"
                              />
                            </label>
                          </span>
                        </Col>
                        {userState.user.role === "owner" ? null : (
                          <FormGroup
                            className={classnames({
                              focused: focusedEnviroMasterChecklist,
                            })}
                          >
                            <Input
                              id="3"
                              type="select"
                              defaultValue={enviroMasterChecklist === true ? "2" : enviroMasterChecklist === false ? "3" : '1'}
                              valid={validEnviroMasterChecklist === "valid"}
                              invalid={validEnviroMasterChecklist === "invalid"}
                              onFocus={() =>
                                setFocusedEnviroMasterChecklist(true)
                              }
                              onBlur={() =>
                                setFocusedEnviroMasterChecklist(false)
                              }
                              onChange={e => {
                                setEnviroMasterChecklist(
                                  e.target.value === "2"
                                );
                                if (
                                  ![
                                    "2",
                                    "3",
                                  ].includes(e.target.value)
                                ) {
                                  setValidEnviroMasterChecklist("invalid");
                                } else {
                                  setValidEnviroMasterChecklist("valid");
                                }
                              }}
                            >
                              <option className="d-none" value="1">
                                Who should to complete this checklist?
                              </option>
                              <option value="2">Enviro-Master's Technician</option>
                              <option value="3">Location's Manager</option>
                            </Input>
                          </FormGroup>
                        )}
                      </Row>
                      {QRNeeded ? 
                        (
                          <Row className="pb-5">
                            <Col>
                            <Button color="primary" type="button" onClick={() => {
                              setAlert(
                                <ReactBSAlert
                                  info
                                  showCancel
                                  style={{ display: "block", marginTop: "-100px" }}
                                  title={checklistName}
                                  onConfirm={() => {
                                    handlePrint();
                                    setAlert(null);
                                  }}
                                  onCancel={() => setAlert(null)}
                                  confirmBtnBsStyle="warning"
                                  confirmBtnText="Print Now"
                                  cancelBtnBsStyle="primary"
                                  cancelBtnText="Print Later"
                                  btnSize=""
                                >
                                  <p>This is the QR code for your checklist. Please select if you want to print it now or later.</p>
                                  <div ref={qrCodeRef} className="d-flex justify-content-center align-items-center" style={{ width: '100%', height: '300px' }}>
                                    <QRCode value={`${franchiseSelect}%${locationSelect}%${checklistName}`}/>
                                  </div>
                                </ReactBSAlert>
                              );
                            }}>
                              Generate QR code
                            </Button>
                            </Col>
                          </Row>
                        )
                      : null}
                    </Form>
                  </Card>
                </div>
              </Row>
            </div>
            <div className="modal-footer">
              <Button color="primary" type="button" type="submit" form="form" disabled={userState.user.role ==='owner' && checklistToUpdate && checklistToUpdate.location === "All Locations (General Checklist)"}>
                {modalTitle}
              </Button>
              <Button color="secondary" onClick={() => {
                setModalAdd(false);
                clearState();
              }}>
                Close
              </Button>
            </div>
          </Modal>

          <Modal
            isOpen={modalCopy}
            toggle={() => {
              setModalCopy(false);
              clearState();
            }}
            className="modal-dialog-centered modal-secondary"
            style={{ width: "90%", maxWidth: "1200px" }}
          >
            <div className="modal-body">
              <Row>
                <div className="col">
                  <Card className="shadow px-6">
                    <CardHeader className="bg-transparent border-0">
                      <h3 className="mb-0">Copy Checklist <span className="text-primary">{checklistToCopy ? checklistToCopy.name : ''}</span></h3>
                    </CardHeader>
                    <Form
                      className="edit-event--form pt-3"
                      id="form"
                      onSubmit={e => handleCopy(e)}
                    >
                      <FormGroup>
                        <label
                          className="text-muted"
                          htmlFor="exampleFormControlSelect2"
                        >
                          Select the franchises the checklist will be copied
                          to.
                        </label>
                        <Select2
                          className="form-control"
                          multiple
                          data={Object.keys(checklistsState.franchises)}
                          // style={validFranchiseSelect === "valid" ? {borderColor: '#2dce89'} : validFranchiseSelect === "invalid" ? {borderColor: '#fb6340'} : {}}
                          onFocus={() => setFocusedFranchiseSelect(true)}
                          onBlur={() => setFocusedFranchiseSelect(false)}
                          onSelect={e => {
                            setFranchiseSelect(prevState =>
                              prevState.concat([e.params.data.text])
                            );
                          }}
                          onUnselect={e => {
                            setFranchiseSelect(prevState =>
                              prevState.filter(
                                franchise => franchise !== e.params.data.text
                              )
                            );
                          }}
                          value={franchiseSelect}
                        />
                      </FormGroup>
                      {franchiseSelect.length > 0 ? (
                        locationSelect.length === 0 && userState.user.role !== 'owner' ? (
                          <FormGroup>
                            <label
                              className="text-muted"
                              htmlFor="exampleFormControlSelect2"
                            >
                              Please select the location(s) where this checklist
                              should be completed
                            </label>
                            <Select2
                              className="form-control"
                              multiple
                              data={[
                                "All Locations (General Checklist)",
                                ...Object.keys(checklistsState.franchises)
                                  .map(franchise => {
                                    if (!franchiseSelect.includes(franchise))
                                      return null;
                                    return [
                                      ...checklistsState.franchises[
                                        franchise
                                      ].locations.map(
                                        location => location.address
                                      ),
                                    ];
                                  })
                                  .flat()
                                  .filter(item => item),
                              ]}
                              // style={validFranchiseSelect === "valid" ? {borderColor: '#2dce89'} : validFranchiseSelect === "invalid" ? {borderColor: '#fb6340'} : {}}
                              onFocus={() => setFocusedLocationSelect(true)}
                              onBlur={() => setFocusedLocationSelect(false)}
                              onSelect={e => {
                                setLocationSelect(prevState =>
                                  prevState.includes(e.params.data.text)
                                    ? prevState
                                    : prevState.concat([e.params.data.text])
                                );
                              }}
                              onUnselect={e => {
                                setLocationSelect(prevState =>
                                  prevState.filter(
                                    location => location !== e.params.data.text
                                  )
                                );
                              }}
                              value={locationSelect}
                            />
                            <div className="invalid-feedback">
                              Please choose a username.
                            </div>
                          </FormGroup>
                        ) : locationSelect.includes(
                            "All Locations (General Checklist)"
                          ) ? (
                          <FormGroup>
                            <label
                              className="text-muted"
                              htmlFor="exampleFormControlSelect2"
                            >
                              Please select the location(s) where this checklist
                              should be completed
                            </label>
                            <Select2
                              className="form-control"
                              multiple
                              data={["All Locations (General Checklist)"]}
                              // style={validFranchiseSelect === "valid" ? {borderColor: '#2dce89'} : validFranchiseSelect === "invalid" ? {borderColor: '#fb6340'} : {}}
                              onFocus={() => setFocusedLocationSelect(true)}
                              onBlur={() => setFocusedLocationSelect(false)}
                              onSelect={e => {
                                setLocationSelect(prevState =>
                                  prevState.includes(e.params.data.text)
                                    ? prevState
                                    : prevState.concat([e.params.data.text])
                                );
                              }}
                              onUnselect={e => {
                                setLocationSelect(prevState =>
                                  prevState.filter(
                                    location => location !== e.params.data.text
                                  )
                                );
                              }}
                              value={locationSelect}
                            />
                            <div className="invalid-feedback">
                              Please choose a username.
                            </div>
                          </FormGroup>
                        ) : (
                          <FormGroup>
                            <label
                              className="text-muted"
                              htmlFor="exampleFormControlSelect2"
                            >
                              Please select the location(s) where this checklist
                              should be completed
                            </label>
                            <Select2
                              className="form-control"
                              multiple
                              data={Object.keys(checklistsState.franchises)
                                .map(franchise => {
                                  if (!franchiseSelect.includes(franchise))
                                    return null;
                                  return [
                                    ...checklistsState.franchises[
                                      franchise
                                    ].locations.map(
                                      location => location.address
                                    ),
                                  ];
                                })
                                .flat()
                                .filter(item => item)}
                              // style={validFranchiseSelect === "valid" ? {borderColor: '#2dce89'} : validFranchiseSelect === "invalid" ? {borderColor: '#fb6340'} : {}}
                              onFocus={() => setFocusedLocationSelect(true)}
                              onBlur={() => setFocusedLocationSelect(false)}
                              onSelect={e => {
                                setLocationSelect(prevState =>
                                  prevState.includes(e.params.data.text)
                                    ? prevState
                                    : prevState.concat([e.params.data.text])
                                );
                              }}
                              onUnselect={e => {
                                setLocationSelect(prevState =>
                                  prevState.filter(
                                    location => location !== e.params.data.text
                                  )
                                );
                              }}
                              value={locationSelect}
                            />
                            <div className="invalid-feedback">
                              Please choose a username.
                            </div>
                          </FormGroup>
                        )
                      ) : null}
                    </Form>
                  </Card>
                </div>
              </Row>
            </div>
            <div className="modal-footer">
              <Button color="primary" type="button" type="submit" form="form">
                Copy checklist
              </Button>
              <Button color="secondary" onClick={() => {
                setModalCopy(false);
                clearState();
              }}>
                Close
              </Button>
            </div>
          </Modal>

        </Row>
      </Container>
    </>
  );
}

export default Checklist;
